import { useContext, useEffect, useState } from "react";
import Button1 from "../../../Button/Button1"
import { RuleProvider, useRule } from "./RuleReducer";
import ListOption from "../EditAutomations/ListOption";
import Button2 from "../../../Button/Button2";
import classes from '../CreateRule/SelectOutputs.module.css'
import ProgressBar from "./ProgressBar";
import { Button } from "primereact/button";
import RoundedInput from "../EditAutomations/RoundedInput";
import { Calendar } from "primereact/calendar";

const ChooseWhen = ({ navigate }) => {
    const { state, dispatch } = useRule(RuleProvider);
    const [disabled, setDisabled] = useState(true)
    const [progress, setProgress] = useState(40)
    const [showDayConditions, setShowDayConditions] = useState(false)
    const [daysSelected, setDaysSelected] = useState(state.days_of_week)
    const [showTimeOptions, setShowTimeOptions] = useState(false)
    const [showDaysOptions, setShowDaysOptions] = useState(false)
    const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];
    const [startTimeRaw, setStartTimeRaw] = useState()
    const [startTime, setStartTime] = useState()
    const [endTimeRaw, setEndTimeRaw] = useState()
    const [endTime, setEndTime] = useState()

    const [pinState, setPinState] = useState("")
    //let pin_state = !state.isLock ? "ARMED" : "DISARMED"

    useEffect(() => {
    }, [])

    const HandleChooseWhenSelected = (selection) => {
        dispatch({ type: "SET_INPUT_TYPE", payload: selection })
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: selection })
        
        switch (selection) {
            case 0:
                setPinState("ARMED")
                break;
            case 1:
                setPinState("ANY")
                break;
            case 2:
                setPinState("DISARMED")
                break;
        }

        setDisabled(false)
    }

    useEffect(() => {
        const updatedCondition = state.conditions.map(condition => {
                if (
                    condition.pin === state.selectedRulePin.Pin
                ) {
                    return {
                        ...condition,
                        days_of_week: JSON.stringify(daysSelected.map(Number)),
                        ...(startTime ? { time_window_start: startTime } : {}),
                        ...(endTime ? { time_window_end: endTime } : {}),
                        ...(endTime && endTime ? { time_condition: "DURING" } : {}),
                        pin_state: pinState
                    };
                }
                return condition;
            });

            dispatch({
                type: "SET_ADV_RULE_CONDITION",
                payload: updatedCondition
            });

    }, [pinState, startTime, endTime, daysSelected])

    const convertDaysOfTheWeek = () => {
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(dayNumber => Days[dayNumber])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
            return "on weekends";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const HandleText = () => {
        let inputType;
        switch (state.inputTypeCopy) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                if (state.isLock) {
                    inputType = "closed"
                }
                break;
            case 1:
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                if (state.isLock) {
                    inputType = "unlocked or closed"
                }
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                if (state.isLock) {
                    inputType = "unlocked"
                }
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                break;
            default:
                inputType = "unknown";
                break;
        }

        if (state.isPulse) {
            inputType = `temporarily ${state.pinStatusOff}`
        }

        // if (state.isLock) {
        //     inputType = "opened"
        // }

        if (state.days_of_week.length < 7) {
            return `Only when ${state.pinName} is ${inputType} ${convertDaysOfTheWeek()}`
        } else {
            return `When ${state.pinName} is ${inputType}`
        }
    }

    const HandleNavigate = (direction) => {
        
        if (direction === "back") {
            navigate(0)
        } else {
            navigate(2)
        }
    }

    const HandleOnDayClicked = (dayIndex) => {
        const isDayAlreayClicked = daysSelected.find(Day => Day == dayIndex);
        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const addItem = (dayIndex) => {
        const newArray = [...daysSelected];
        newArray.push(dayIndex);
        setDaysSelected(newArray);

        //dispatch new state
        dispatch({
            type: "SET_EXECUTION_DAYS",
            payload: newArray
        });
    };

    const removeItem = (dayIndex) => {
        const newArray = [...daysSelected];
        const filterArray = newArray.filter(Day => Day !== dayIndex)
        setDaysSelected(filterArray);

        //dispatch new state
        dispatch({
            type: "SET_EXECUTION_DAYS",
            payload: filterArray
        });
    }

    const cancelTimeRestrictions = () => {
        setShowTimeOptions(false)
        setStartTime(null)
        setEndTime(null)
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px", width: "80%" }}>
            <ProgressBar progress={progress} />
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "20px" }}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                {/* <ListOption optionText={HandleText()} propsClassName={classes.infoBox} /> */}
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            <h3 style={{ color: "#6e6e6e" }}>When will the rule trigger?</h3>
            <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                {!state.isPulse && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 0 && "var(--Primary-Color)",
                            color: state.inputType == 0 && "white",
                            border: state.inputType == 0 && "2px solid lightblue",
                            whiteSpace: "normal"        // allow wrapping/new lines
                        }}
                        onClick={() => HandleChooseWhenSelected(0)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOn}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is closed</span>
                                <span style={{ fontStyle: "italic", fontSize: "0.9em" }}>(Requires BLE Gateway)</span>
                            </div>
                        )}
                    </Button2>
                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 1 && "var(--Primary-Color)",
                            color: state.inputType == 1 && "white",
                            border: state.inputType == 1 && "2px solid lightblue",
                            whiteSpace: "normal"        // allow wrapping/new lines
                        }}
                        onClick={() => HandleChooseWhenSelected(1)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOn} or {state.pinStatusOff}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is unlocked or closed</span>
                                <span style={{ fontStyle: "italic", fontSize: "0.9em" }}>(Requires BLE Gateway)</span>
                            </div>
                        )}
                    </Button2>
                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 2 && "var(--Primary-Color)",
                            color: state.inputType == 2 && "white",
                            border: state.inputType == 2 && "2px solid lightblue",
                            whiteSpace: "normal"        // allow wrapping/new lines
                        }}
                        onClick={() => HandleChooseWhenSelected(2)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOff}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is unlocked</span>
                            </div>
                        )}
                    </Button2>
                    <br />
                </div>}
                {state.isPulse &&
                    <Button2 style={{
                        minWidth: "450px",
                        minHeight: "50px",
                        backgroundColor: "var(--Primary-Color)",
                        color: "white",
                        border: "2px solid lightblue", minWidth: "300px"
                    }}>
                        {`When ${state.pinName} is temporarily ${state.pinStatusOff}`}
                    </Button2>
                }

                {state.supportsAdvRules &&
                    <div>
                        <div className={classes.verticalFlex}>
                            {showDaysOptions && <div><h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>On:</h4>
                            <ul className={classes.horizontalFlex}>
                                {["0", "1", "2", "3", "4", "5", "6"].map((dayIndex, index) => (
                                    <li key={index}>
                                        <Button2 style={{ backgroundColor: daysSelected.find(Day => Day == dayIndex) && "var(--Primary-Color)", color: daysSelected.find(Day => Day == dayIndex) && "white", minWidth: "60px", minHeight: "30px" }} onClick={() => HandleOnDayClicked(dayIndex)}>{Days[dayIndex]}</Button2>
                                    </li>
                                ))}
                            </ul> 
                            <br />
                            </div>}
                            
                            <Button visible={!showDaysOptions} label="Add days of the week restrictions?" severity="info" rounded icon="pi pi-plus" onClick={() => setShowDaysOptions(true)} />
                            <Button visible={!showTimeOptions} label="Add time restrictions?" severity="info" rounded icon="pi pi-plus" onClick={() => setShowTimeOptions(true)} />
                        </div>

                        {showTimeOptions &&
                            <div className={classes.verticalFlex} style={{ position: "relative" }}>
                                <div style={{ position: "absolute", left: "450px", bottom: "130px", textAlign: "center", borderRadius: "50%", border: "1px solid grey", width: "20px", height: "fit-content", cursor: "pointer" }} onClick={() => cancelTimeRestrictions()}>X</div>

                                <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>Between:</h4>

                                <Calendar
                                    value={startTimeRaw}
                                    onChange={(e) => {
                                        const date = e.value;
                                        const hours = date.getHours().toString().padStart(2, "0");
                                        const minutes = date.getMinutes().toString().padStart(2, "0");
                                        setStartTime(`${hours}:${minutes}:00`);
                                        setStartTimeRaw(e.value)
                                    }}
                                    timeOnly
                                />
                                <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>and</h4>
                                <Calendar
                                    value={endTimeRaw}
                                    onChange={(e) => {
                                        const date = e.value;
                                        const hours = date.getHours().toString().padStart(2, "0");
                                        const minutes = date.getMinutes().toString().padStart(2, "0");
                                        setEndTime(`${hours}:${minutes}:00`);
                                        setEndTimeRaw(e.value)
                                    }}
                                    timeOnly
                                />
                            </div>
                        }
                    </div>

                }
            </ul>
        </div>
    )
}

export default ChooseWhen;